import script from "./ParticleScene.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticleScene.vue?vue&type=script&setup=true&lang=js"

import "./ParticleScene.vue?vue&type=style&index=0&id=35517b0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35517b0b"]])

export default __exports__